import Config from '../../config';
import $ from 'jquery';
import axios from 'axios';
import store from 'WebsiteApp/logic/store/AppStore';
import { logoutTriggerAction } from 'WebsiteApp/modules/auth/AuthActions';
import { Logger } from 'WebsiteApp';
import i18n from 'WebsiteApp/i18n';

export default class Api {

  static getBaseUrl() {
    return Config.url;
  }

  static call(method, data, onProgress, headers = {}) {
    let authToken = store.getState().auth.token || null;

    let requestUrl = this.getBaseUrl() + method;
    let ajaxOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language
      },
      method: 'POST',
      contentType: 'application/json',
      body: JSON.stringify(data),
    };

    if (authToken) {
      ajaxOptions.headers['Authorization'] = 'Bearer ' + authToken;
    }

    ajaxOptions.headers = {...ajaxOptions.headers, ...headers};

    Logger.log('api options', requestUrl, ajaxOptions);
    Logger.log('api request', requestUrl, data);

    return new Promise((resolve, reject) => {
      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        }
      }

      axios({
        url: this.getBaseUrl() + method,
        method: 'POST',
        contentType: 'application/json',
        processData: false,
        headers: ajaxOptions['headers'],
        data: JSON.stringify(data),
        onUploadProgress: function(progressEvent) {
          if(onProgress) {
            onProgress(progressEvent);
          }
        }
        // success: function (data) {
        //   resolve(data);
        // },
        // error: function (data) {

        //   if (data.status == 403) {
        //     store.dispatch(logoutTriggerAction())
        //   }

        //   Logger.log('data', data);
        //   reject(data);
        // }
      }, config).then(response => {
        Logger.log('api response', requestUrl, response.data);
        resolve(response.data);
      }).catch((error, ...rest) => {
        Logger.log('API error ' + JSON.stringify(error, null, 3), rest)
        if (error.response) {

          Logger.log('data', error.response);

          if(error.response.status == 403) {
            store.dispatch(logoutTriggerAction());
          }

          if(error.response.status == 200) {
            let code = error.response.data.code;

            if(code == 401 || code == 403) {
              store.dispatch(logoutTriggerAction())
            }
          }
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
        } else {
          // Something happened in setting up the request that triggered an Error
        }
        reject(error);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/logic/api/Api.js